import PropTypes from 'prop-types';
import React from 'react';

const logo = new URL('../../img/logo.png', import.meta.url).toString();

const Header = (props) => (
	<header
		className={`bsknacht17-site-title js-bsknacht17-state--${props.view}`}
	>
		<h1>Braunschweiger Kulturnacht 2023</h1>
		<img src={logo} width="109" height="63" alt="" />
	</header>
);

Header.propTypes = {
	view: PropTypes.string.isRequired,
};

export default Header;
